import React, { useState } from 'react'
import { Play, Tv, ArrowRight } from 'lucide-react'

const featuredVideos = [
  { id: 'david-intro', title: 'David Benaim — Expert Capillaire', duration: '0:30', poster: '/media-bentv/greffe/david-intro.webp' },
  { id: 'francois-vacanti', title: 'François — Témoignage', duration: '0:50', poster: '/media-bentv/greffe/francois-vacanti.webp' },
  { id: 'bastien-temoignage', title: 'Bastien — Avant/Après', duration: '1:11', poster: '/media-bentv/greffe/bastien-temoignage.webp' },
  { id: 'epilation-laser', title: 'Épilation Laser', duration: '0:22', poster: '/media-bentv/epilation/epilation-laser.webp' },
]

const BenTVTeaser = () => {
  const [hoveredCard, setHoveredCard] = useState(null)

  return (
    <section className="bentv-teaser">
      <div className="bentv-teaser-inner">
        {/* Ben portrait — the star */}
        <div className="bentv-teaser-ben">
          <div className="bentv-teaser-ben-ring">
            <img
              src="/media-bentv/ben-tv-host-vertical.webp"
              alt="Ben — Votre présentateur"
            />
          </div>
          <div className="bentv-teaser-ben-label">
            <Tv size={14} />
            <span>Présentateur</span>
          </div>
        </div>

        {/* Center: Branding + subtitle */}
        <div className="bentv-teaser-center">
          <div className="bentv-teaser-badge">
            <span className="bentv-teaser-badge-dot" />
            Nouveau
          </div>
          <h2 className="bentv-teaser-title">
            BEN <span>TV</span>
          </h2>
          <p className="bentv-teaser-subtitle">
            Témoignages, expertises et coulisses de la clinique — présentés par Ben
          </p>

          {/* Video thumbnails row */}
          <div className="bentv-teaser-videos">
            {featuredVideos.map((video) => (
              <a
                key={video.id}
                href="/ben-tv"
                className="bentv-teaser-card"
                onMouseEnter={() => setHoveredCard(video.id)}
                onMouseLeave={() => setHoveredCard(null)}
                style={{
                  transform: hoveredCard === video.id ? 'scale(1.08) translateY(-4px)' : 'scale(1)',
                }}
              >
                <div className="bentv-teaser-card-inner">
                  <img src={video.poster} alt={video.title} loading="lazy" />
                  <div className="bentv-teaser-card-play">
                    <Play size={16} color="#fff" fill="#fff" />
                  </div>
                  <div className="bentv-teaser-card-duration">{video.duration}</div>
                  <div className="bentv-teaser-card-title">
                    <p>{video.title}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>

          <a href="/ben-tv" className="bentv-teaser-cta">
            Découvrir Ben TV
            <ArrowRight size={18} />
          </a>
        </div>
      </div>

      <style>{`
        .bentv-teaser {
          position: relative;
          overflow: hidden;
          background: linear-gradient(160deg, #0a0a1a 0%, #151535 40%, #1a1040 70%, #0a0a1a 100%);
        }

        /* Subtle decorative glow */
        .bentv-teaser::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -20%;
          width: 600px;
          height: 600px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(47, 47, 132, 0.15) 0%, transparent 70%);
          pointer-events: none;
        }

        .bentv-teaser::after {
          content: '';
          position: absolute;
          bottom: -40%;
          left: -15%;
          width: 500px;
          height: 500px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(139, 111, 71, 0.1) 0%, transparent 70%);
          pointer-events: none;
        }

        .bentv-teaser-inner {
          position: relative;
          z-index: 1;
          max-width: 1100px;
          margin: 0 auto;
          padding: 4rem 2rem;
          display: flex;
          align-items: center;
          gap: 3rem;
        }

        /* ── Ben portrait ── */
        .bentv-teaser-ben {
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
        }

        .bentv-teaser-ben-ring {
          width: 180px;
          height: 180px;
          border-radius: 50%;
          overflow: hidden;
          border: 3px solid #8B6F47;
          box-shadow:
            0 0 0 6px rgba(139, 111, 71, 0.15),
            0 8px 32px rgba(0, 0, 0, 0.4),
            0 0 60px rgba(47, 47, 132, 0.2);
          position: relative;
        }

        .bentv-teaser-ben-ring img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center 15%;
        }

        .bentv-teaser-ben-label {
          display: flex;
          align-items: center;
          gap: 5px;
          color: #8B6F47;
          font-family: Inter, sans-serif;
          font-size: 0.7rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1.5px;
        }

        /* ── Center content ── */
        .bentv-teaser-center {
          flex: 1;
          min-width: 0;
        }

        .bentv-teaser-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: #d4a853;
          font-family: Inter, sans-serif;
          font-size: 0.75rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 2px;
          margin-bottom: 0.75rem;
        }

        .bentv-teaser-badge-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #e74c3c;
          animation: bentv-dot-pulse 2s infinite;
        }

        @keyframes bentv-dot-pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }

        .bentv-teaser-title {
          font-family: 'Playfair Display', serif;
          font-size: 2.8rem;
          font-weight: 800;
          color: #fff;
          line-height: 1;
          margin: 0 0 0.6rem 0;
        }

        .bentv-teaser-title span {
          color: #8B6F47;
        }

        .bentv-teaser-subtitle {
          font-family: Inter, sans-serif;
          font-size: 0.95rem;
          color: rgba(255, 255, 255, 0.5);
          line-height: 1.5;
          margin: 0 0 1.5rem 0;
          max-width: 440px;
        }

        /* ── Video thumbnails ── */
        .bentv-teaser-videos {
          display: flex;
          gap: 12px;
          margin-bottom: 1.5rem;
          overflow-x: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;
          padding-bottom: 4px;
        }

        .bentv-teaser-videos::-webkit-scrollbar {
          display: none;
        }

        .bentv-teaser-card {
          flex: 0 0 100px;
          text-decoration: none;
          transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }

        .bentv-teaser-card-inner {
          position: relative;
          width: 100%;
          padding-bottom: 155%;
          border-radius: 8px;
          overflow: hidden;
          background: #1a1a2e;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
          border: 1px solid rgba(255, 255, 255, 0.06);
        }

        .bentv-teaser-card-inner img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .bentv-teaser-card-play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: rgba(47, 47, 132, 0.85);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.25s ease;
        }

        .bentv-teaser-card:hover .bentv-teaser-card-play {
          opacity: 1;
        }

        .bentv-teaser-card-duration {
          position: absolute;
          top: 5px;
          right: 5px;
          background: rgba(0, 0, 0, 0.75);
          color: #fff;
          padding: 1px 5px;
          border-radius: 3px;
          font-size: 0.6rem;
          font-weight: 600;
          font-family: Inter, sans-serif;
        }

        .bentv-teaser-card-title {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 20px 6px 6px;
          background: linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 100%);
        }

        .bentv-teaser-card-title p {
          color: #fff;
          font-size: 0.6rem;
          font-weight: 600;
          font-family: Inter, sans-serif;
          line-height: 1.2;
          margin: 0;
        }

        /* ── CTA button ── */
        .bentv-teaser-cta {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 12px 28px;
          border-radius: 50px;
          background: linear-gradient(135deg, #2F2F84 0%, #6466B0 100%);
          color: #fff;
          font-family: Inter, sans-serif;
          font-size: 0.9rem;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.3s ease;
          box-shadow: 0 4px 20px rgba(47, 47, 132, 0.35);
          border: 1px solid rgba(100, 102, 176, 0.3);
        }

        .bentv-teaser-cta:hover {
          transform: translateX(4px);
          box-shadow: 0 6px 28px rgba(47, 47, 132, 0.5);
          background: linear-gradient(135deg, #3a3a9e 0%, #7577c0 100%);
        }

        /* ── Responsive ── */
        @media (max-width: 768px) {
          .bentv-teaser-inner {
            flex-direction: column;
            text-align: center;
            padding: 3rem 1.5rem;
            gap: 1.5rem;
          }

          .bentv-teaser-ben-ring {
            width: 140px;
            height: 140px;
          }

          .bentv-teaser-title {
            font-size: 2.2rem;
          }

          .bentv-teaser-subtitle {
            margin-left: auto;
            margin-right: auto;
          }

          .bentv-teaser-videos {
            justify-content: center;
          }

          .bentv-teaser-card {
            flex: 0 0 85px;
          }
        }

        @media (max-width: 480px) {
          .bentv-teaser-card {
            flex: 0 0 75px;
          }

          .bentv-teaser-title {
            font-size: 1.8rem;
          }
        }
      `}</style>
    </section>
  )
}

export default BenTVTeaser
